import {useEffect,useRef,useCallback} from 'react';
import {showAppConfirm} from '../api';
const pending=new Set();
export async function confirmPendingChanges(){return !pending.size||await showAppConfirm('Ungespeicherte Änderungen verwerfen?',{title:'Änderungen noch nicht gespeichert'})}
export default function useUnsavedChanges(value,close){
 const token=useRef({});
 const initial=useRef(JSON.stringify(value));const dirty=JSON.stringify(value)!==initial.current;
 useEffect(()=>{const key=token.current;if(dirty)pending.add(key);else pending.delete(key);return()=>pending.delete(key)},[dirty]);
 useEffect(()=>{const warn=e=>{if(dirty){e.preventDefault();e.returnValue=''}};window.addEventListener('beforeunload',warn);return()=>window.removeEventListener('beforeunload',warn)},[dirty]);
 return useCallback(async()=>{if(!dirty||await showAppConfirm('Ungespeicherte Änderungen verwerfen?',{title:'Änderungen noch nicht gespeichert'}))close()},[dirty,close]);
}
